import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTextLang, LanguageContext } from './providers/LanguageProvider';
import { Button, Card, Container, ContainerFlex, TextLocalized } from './styled/Styled';
import { getBlockImage } from './util/BlockUtil';


const BlockItem = ({ item, index }) => {
    let history = useNavigate();
    const { language } = useContext(LanguageContext);

    const getProgress = () => {
        return item.progress ? item.progress.toFixed(0) : 0;
    }

    return <Container width="12" sm={index === 0 ? 12 : 6} lg={index === 0 ? 12 : 6} px="4">
        <Card flex direction="column" shadowOn width="12" minheight="100%" color="color-white">
            <ContainerFlex expand width="12">
                <Container width="12">
                    <Card flex justify="center" px="16" width="12" radiusbl="0" radiusbr="0" height="180px" color="color-green-a40">
                        <img height="100%" alt='block' src={getBlockImage(item)} />
                    </Card>
                    <Container width="12" ph="16" mt="16" fontSize="18px" fontWeight="bold" children={getTextLang(item, 'name', language)} />
                    <Container width="12" ph="16" fontSize="14px" pv="16" children={getTextLang(item, 'description_short', language)} />
                </Container>
            </ContainerFlex>
            <ContainerFlex width="12" align="center" pb="16">

                <ContainerFlex width="12" mb="16" align="center" justify="space-between">
                    <Container ph="16" pv="8" fontWeight="bold" fontColor="color-black" children={<TextLocalized children="msgProgress" />} />
                    <Card flex justify="center" align="center" mh="16" border="solid" borderColor="color-primary" borderWidth="2px" radius="50%"
                        fontColor="color-black" fontWeight="bold"
                        minheight="54px" minwidth="54px" children={`${getProgress()}%`} />
                </ContainerFlex>

                <Button onClick={() => history("/section", { state: { item: item } })}
                    width="wrap" mh="8" pv="8" color="color-primary" hoverColor="color-primary-a40"
                    fontColor="color-black" fontWeight="bold" textAlign="center"
                    children={<TextLocalized children={getProgress() === 0 ? "actionStart" : "actionContinue"} />} />
            </ContainerFlex>
        </Card>
    </Container>
};

export default BlockItem;